import { Injectable } from "@angular/core";
import { RcStore } from "./rcStore";
import { RcLoggerService } from "./rcLoggerService";

export enum LocalStorageKeys {
    displayGuideScreenshot = 'safariDisplaySaveAsGuideScreenshot',
    displayGuideLogFile = 'safariDisplaySaveAsGuideLogFile',
    screenshotDialogSettings = 'screenshotDialogSettings',
    logDialogSettings = 'logDialogSettings'
}

@Injectable({ providedIn: 'root' })
export class RcConfigurationService {
    constructor(private storage: RcStore, private mcrcLog: RcLoggerService) { }

    public configure() {
        var jsonOptions = this.storage.loadString(LocalStorageKeys.logDialogSettings);
        if (!jsonOptions) {
            // Add the default logging settings, so it can be manually edited if needed
            jsonOptions = '{\"logLevel\":\"Error\",\"logLineLimit\":\"10000\"}';
            this.storage.storeString(LocalStorageKeys.logDialogSettings, jsonOptions);
        }

        const options = JSON.parse(jsonOptions);
        this.mcrcLog.lineLimit(options.logLineLimit);
        this.mcrcLog.setLogLevel(options.logLevel);
    }
}